module.exports = __webpack_public_path__ + "img/virgin-islands.6f4e038b.png";